/**
 * FH-A11Y batch 23 (2026-10-03): two small screen reader fixes.
 *   1. Product photo thumbnails: the list items are layout-only (role "presentation") but also carried
 *      aria-hidden="false", which audit tools flag as a conflict (axe presentation-role-conflict).
 *      ada-a11y-fixes.js writes that value on every pass, so it is dropped at the source for these items.
 *   2. Desktop menu, "Sale": it was announced as a link that is "collapsed", but Enter went straight to the
 *      Sale page, so the submenu could only be opened with Space. It now behaves like Rugs, Accessories and
 *      About: a button, and Enter or Space opens the submenu (which has a "shop all" link to the Sale page).
 *      Mouse clicks still go to the Sale page as before.
 * Rollback: remove the batch 23 line at the end of snippets/freshdesk.liquid.
 */
(function () {
  'use strict';
  if (window.__fhA11yBatch23) return;
  window.__fhA11yBatch23 = true;

  /* 1: thumbnails */
  function fixThumbs() {
    var items = document.querySelectorAll('li[id^="Slide-Thumbnails"]');
    for (var i = 0; i < items.length; i++) {
      var li = items[i];
      if (!li.__fh23) {
        li.__fh23 = true;
        (function (el) {
          var orig = el.setAttribute;
          el.setAttribute = function (name, value) {
            if (name === 'aria-hidden' && String(value) === 'false') {
              if (el.hasAttribute('aria-hidden')) el.removeAttribute('aria-hidden');
              return;
            }
            return orig.call(el, name, value);
          };
        })(li);
      }
      if (li.getAttribute('aria-hidden') === 'false') li.removeAttribute('aria-hidden');
    }
  }

  /* 2: menu items that are a real link and also open a submenu */
  function openSubmenu(a) {
    /* The menu app toggles the submenu on a Space key press. */
    a.dispatchEvent(new KeyboardEvent('keydown', { key: ' ', code: 'Space', keyCode: 32, which: 32, bubbles: true, cancelable: true }));
  }
  function fixMenu() {
    var links = document.querySelectorAll('.tmenu_navbar .tmenu_item--root.tmenu_item_has_child > a.tmenu_item_link[aria-haspopup]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      var href = a.getAttribute('href') || '';
      if (!href || /^(javascript:|#)/i.test(href)) continue; /* the others are handled in batch 9 */
      if (a.getAttribute('role') !== 'button') a.setAttribute('role', 'button');
      if (a.__fh23) continue;
      a.__fh23 = true;
      (function (link) {
        link.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' || !e.isTrusted) return;
          e.preventDefault();
          e.stopPropagation();
          openSubmenu(link);
        }, true);
        /* Screen readers activate with a click that has no pointer behind it. */
        link.addEventListener('click', function (e) {
          if (e.detail !== 0 || !e.isTrusted) return;
          e.preventDefault();
          e.stopPropagation();
          openSubmenu(link);
        }, true);
      })(a);
    }
  }

  var timer = 0;
  function run() {
    timer = 0;
    try { fixThumbs(); } catch (e) {}
    try { fixMenu(); } catch (e) {}
  }
  function schedule() {
    if (!timer) timer = setTimeout(run, 150);
  }
  function start() {
    run();
    /* The menu app and the photo gallery are added or rebuilt after the page loads. */
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
